import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-loading-view',
    templateUrl: './loading-view.component.html',
    styleUrls: ['./loading-view.component.css'],
    standalone: false
})
export class LoadingViewComponent implements OnInit {

  @Input() loaded;

  @Input() empty;

  @Input() errGettingData;

  constructor() { }

  ngOnInit() {
  }

}
